module.exports = __webpack_public_path__ + "img/tech.c752a2e.png";